import React, { Component } from 'react';
import moment from 'moment';
import { Fragment } from 'react';
import { divisionNumber } from '../../untils/auth'

export default class CouponsItem extends Component {
  state = {
    status: '',
  };
  toPay = e => {
    e.stopPropagation();
    this.props.history.push('/');
  };
  componentDidMount() {
    let { item, price ,couponCodeValue ,msg} = this.props;
    let { status } = this.state;
    // 抵扣劵 满减
    // deduction      可使用
    // dissatisfy-mj  不可使用 
    // deduction-used 使用过

    // 折扣卷
    // iscount 可使用
    // dissatisfy-zk 不可使用 
    // iscount-used 使用过
    
    if (item.cType === 'voucher') {
      if (couponCodeValue && msg === '' && item.useRestriction === 'cannot-with-coupon-code') {
        status = 'disable-used-voucher';
      }else{
        if (item.status === 1) {
          if (item.cValue !== undefined) {
            if (Number(item.condValue) > price) {
              status = 'dissatisfy-mj';
            } else {
              status = 'deduction';
            }
          }
        } else {
          status = 'deduction-used';
        }
      }

    } else {
      if (couponCodeValue && msg === '' && item.useRestriction === 'cannot-with-coupon-code') {
        status = 'disable-used-discount';
      } else {
          if (item.status === 1) {
            if (item.cValue !== undefined ) {
              if (Number(item.condValue) > price) {
                status = 'dissatisfy-zk';
              } else {
                status = 'iscount';
              }
            }
          } else {
            status = 'iscount-used';
          }
        }
      }
    
    this.setState({
      status,
    });
  }
  render() {
    let { item, pay  } = this.props;
    let { status } = this.state; 
    return (
      <div
        className={`coupons-item bg-image ${status} `}
        // onClick={() => this.props.clickCoupon(item)}
      >
        <div className="coupons-left">
          <span>
            <i>
              {item.cType === 'voucher' ? `$ ${divisionNumber(item.cValue)}` : `${item.cValue}% OFF`}
            </i>
            {/* <i>No threshold of use</i> */}
            <i>
              {item['condValue'] !== undefined ? (
                <Fragment>
                  <span>Available for orders </span>    
                  <span>over ${item.condValue}</span>
                </Fragment>
              ) : (
                'No threshold of use'
              )}
            </i>  
            {item.status === 1 && !pay ? (
              status !== 'dissatisfy' ? (
                <b onClick={e => this.toPay(e)}>To use</b>
              ) : null
            ) : null}
          </span>
        </div>
        <div className="coupons-right">
          <p>{item.Name}</p>
          {/* <p>Gift Voucher</p> */}
          {item['endTime'] !== undefined ? (
            <span>
              {moment(item.startTime).format('YYYY.MM.DD HH:00')} -{' '}
              {moment(item.endTime).format('YYYY.MM.DD HH:00')}
            </span>
          ) : item['startTime'] !== undefined ? (
            <span>{item.startTime}</span>
          ) : (
            <span>Unlimited</span>
          )}

          <i>
            Applicable Products：<div>
                {item.useEle.map((item,index)=>{
                  return (
                    <span key={index}>{item}</span>
                  )
                })}
            </div>
          </i>
        </div>
        <div
          className={`not-coupons bg-image ${
            item.status === 3 ? 'used' : item.status === 2 ? 'over' : ''
          }`}
        ></div>
      </div>
    );
  }
}
